// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1Vr7x","footer":"ModalInfo_footer__3TyRc"};